import { AxiosError } from "axios";

import { api } from "@/lib/axios";

export interface ResetForgotPasswordBody {
	email: string;
	token: string;
	password: string;
	password_confirmation: string;
}

export async function resetForgotPassword({
	email,
	token,
	password,
	password_confirmation,
}: ResetForgotPasswordBody): Promise<
	| { status: "success"; data: { [key: string]: string } }
	| { status: "error"; errors: { [key: string]: string } }
> {
	try {
		const { data } = await api.post("/auth/reset-password", {
			email,
			token,
			password,
			password_confirmation,
		});

		return {
			status: "success",
			data,
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
		}>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
